import { Injectable } from '@angular/core';
import {
  Faro,
  getWebInstrumentations,
  initializeFaro,
  MetaUser,
  MetaView,
  PushErrorOptions,
} from '@grafana/faro-web-sdk';
import { APP_VERSION } from '../../common/constants/app-version';
import { EnvironmentName } from './environment.constant';

const LOCAL_ENVIRONMENTS: string[] = [EnvironmentName.Local, EnvironmentName.Mock];

@Injectable({ providedIn: 'root' })
export class FaroService {
  private faro: Faro | undefined;

  public initialize(collectorUrl: string, apiKey: string, environment: string): void {
    if (LOCAL_ENVIRONMENTS.includes(environment)) {
      return;
    }

    this.faro = initializeFaro({
      url: collectorUrl,
      apiKey,
      app: {
        name: 'intrack-web-app',
        version: APP_VERSION,
        environment,
      },
      instrumentations: [...getWebInstrumentations()],
    });
  }

  public setUser(user: MetaUser): void {
    this.faro?.api.setUser(user);
  }

  public resetUser(): void {
    this.faro?.api.resetUser();
  }

  public setView(view: MetaView): void {
    this.faro?.api.setView(view);
  }

  public pushError(error: Error, options?: PushErrorOptions): void {
    this.faro?.api.pushError(error, options);
  }

  public getFaro(): Faro | undefined {
    return this.faro;
  }
}
